import { defineAction } from '~/prix'
import { z } from 'zod'
import creditRequestReportAction from './creditRequestReport.action.json' with { type: 'json' }
import { creditRequestReportTypeSchema } from './creditRequestReportShared'

const creditRequestReportDefinition = defineAction({
  ...creditRequestReportAction,

  input: z.object({
    id: z.string().uuid(),
    reportType: creditRequestReportTypeSchema,
    format: z.literal('pdf').default('pdf'),
  }),
  output: z.any(),
})

export default creditRequestReportDefinition
